import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RetrospectiveCheckedArea from "../../components/RetrospectiveCheckedArea";
import { selectCompletedSprintList, selectSprintFormDta } from "../../redux/selector";
import { actions } from "../../redux/slice";
import DateSelection from "./DateSelection";
import ScrumMaster from "./ScrumMaster";
import SelectSprint from "./SelectSprint";
import SprintMember from "./SprintMember";

const RightArea = () => {
  const dispatch = useDispatch();
  const form = useSelector(selectSprintFormDta);
  const completeSprints = useSelector(selectCompletedSprintList);

  useEffect(() => {
    if (completeSprints) {
      const firstSprint = completeSprints[0] ||{};
      dispatch(actions.setSprintMembers(firstSprint?.members));
      dispatch(
        actions.updateFormValue({
          key: "selectedSprint",
          value: firstSprint?._id,
        })
      );
      dispatch(
        actions.updateFormValue({
          key: "scrumMasterId",
          value: firstSprint?.scrumMasterId,
        })
      );
      dispatch(
        actions.updateFormValue({
          key: "startDate",
          value: firstSprint?.startDate,
        })
      );
      dispatch(
        actions.updateFormValue({ key: "endDate", value: firstSprint?.endDate })
      );
    }
    return () => {};
  }, [completeSprints]);

  return (
    <div className=" flex flex-col gap-4 w-full ">
      <SelectSprint selectedSprint={form?.selectedSprint} />
      <SprintMember selectedIds={form.sprintMembers} />
      <ScrumMaster selectedId={form.scrumMasterId} />
      <DateSelection startDate={form.startDate} endDate={form.endDate} />
      <RetrospectiveCheckedArea
        isChecked={form.sendRetrospectiveRequest}
        onChecked={() => {
          dispatch(
            actions.updateFormValue({
              key: "sendRetrospectiveRequest",
              value: !form.sendRetrospectiveRequest,
            })
          );
        }}
      />
    </div>
  );
};

export default RightArea;
